module.exports = __webpack_public_path__ + "3b6a1730adc02cbda0cbb180650dec4b.png";